import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgSalary(props: RootSvgProps) {
  return (
    <RootSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_168_4572)">
        <path
          d="M7 13.8077C7.22567 13.8077 7.41667 13.7295 7.573 13.573C7.7295 13.4167 7.80775 13.2257 7.80775 13C7.80775 12.7743 7.7295 12.5833 7.573 12.427C7.41667 12.2705 7.22567 12.1923 7 12.1923C6.77433 12.1923 6.58333 12.2705 6.427 12.427C6.2705 12.5833 6.19225 12.7743 6.19225 13C6.19225 13.2257 6.2705 13.4167 6.427 13.573C6.58333 13.7295 6.77433 13.8077 7 13.8077ZM7 9.80775C7.22567 9.80775 7.41667 9.7295 7.573 9.573C7.7295 9.41667 7.80775 9.22567 7.80775 9C7.80775 8.77433 7.7295 8.58333 7.573 8.427C7.41667 8.2705 7.22567 8.19225 7 8.19225C6.77433 8.19225 6.58333 8.2705 6.427 8.427C6.2705 8.58333 6.19225 8.77433 6.19225 9C6.19225 9.22567 6.2705 9.41667 6.427 9.573C6.58333 9.7295 6.77433 9.80775 7 9.80775ZM9.05775 13.75H17.75V12.25H9.05775V13.75ZM9.05775 9.75H17.75V8.25H9.05775V9.75ZM8.5 20.5V18.5H4.30775C3.80258 18.5 3.375 18.325 3.025 17.975C2.675 17.625 2.5 17.1974 2.5 16.6923V5.30775C2.5 4.80258 2.675 4.375 3.025 4.025C3.375 3.675 3.80258 3.5 4.30775 3.5H19.6923C20.1974 3.5 20.625 3.675 20.975 4.025C21.325 4.375 21.5 4.80258 21.5 5.30775V16.6923C21.5 17.1974 21.325 17.625 20.975 17.975C20.625 18.325 20.1974 18.5 19.6923 18.5H15.5V20.5H8.5ZM4.30775 17H19.6923C19.7693 17 19.8398 16.9679 19.9038 16.9038C19.9679 16.8398 20 16.7692 20 16.6923V5.30775C20 5.23075 19.9679 5.16025 19.9038 5.09625C19.8398 5.03208 19.7693 5 19.6923 5H4.30775C4.23075 5 4.16025 5.03208 4.09625 5.09625C4.03208 5.16025 4 5.23075 4 5.30775V16.6923C4 16.7692 4.03208 16.8398 4.09625 16.9038C4.16025 16.9679 4.23075 17 4.30775 17Z"
          fill="#595959"
        />
      </g>
      <defs>
        <clipPath id="clip0_168_4572">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
